<template>
  <div class="fts-basket" :class="{ active: activeClass }" v-if="visibility">
    <div v-if="mode === 'put'" class="basket-header">
      <div v-for="basket in basketHeader" :key="`sc-${basket.moduleId}`" class="basket-header-wrapper">
        <div class="basket-header-others" v-if="basket.id === 'others'">{{basket.title}}</div>
        <div v-else class="basket-header-group" @click="addToForm(basket)">
          <fts-moji :size="14" :emoji="moduleData(basket.moduleId).emoji" />
          <div class="basket-module-name">{{moduleData(basket.moduleId).name}}</div>
          <div class="basket-items-length ">{{basket.items && basket.items.length}}</div>
        </div>
      </div>
    </div>

    <fts-dropdown-select
      class="basket-dropdown"
      content-class="basket-content basket-dropdown-menu"
      placement="bottom" 
      :offset="[0, 6]">>
      <div slot="toggle" class="basket-toggle">
        <font-awesome-icon :icon="['fas', 'shopping-bag']" size="lg" />
        <div class="basket-count">{{totalBasketItems}}</div>
      </div>
      <template #menu>
        <template v-if="totalBasketItems">
          <div class="basket-group" v-for="basket in basketGroup" :key="basket.id">
            <div class="basket-summary">
              <div class="basket-module">
                <fts-moji :size="20" :emoji="moduleData(basket.moduleId).emoji" class="basket-module-emoji" />
                <div class="basket-module-name">{{moduleData(basket.moduleId).name}}</div>
              </div>
              <div class="basket-items">        
                <div class="basket-items-summary">
                  <template v-if="basket.items.length === 1">{{basket.items[0].title}}</template>
                  <template v-else>{{basket.items.length}} items selected</template>
                </div>
                <div class="basket-items-details">
                  <template v-if="basket.items.length === 1">{{basket.items[0].documentId}}</template>
                  <template v-else>
                    <span class="basket-items-ids">{{basketSelectedItemsEtc(basket.items)}}</span>
                    <span class="basket-items-ids-action" @click="basketExpandDetails(basket)">{{basket.expand ? 'hide details' : 'show details'}}</span>
                  </template>
                </div>
              </div>
              <font-awesome-icon :icon="['far', 'trash-alt']" @click.stop="removeBasketItems(basket.items)" v-if="mode === 'add'" />
              <font-awesome-icon :icon="['fas', 'check']" @click.stop="addToForm(basket)" v-else />
            </div>

            <div class="basket-item-container " v-if="basket.expand && basket.items.length > 1" :key="basket.id">
              <div class="basket-item" v-for="x in basket.items" :key="x.id">
                <div class="basket-item-wrapper">
                  <div class="basket-item-title">{{x.title}}</div>
                  <div class="basket-item-document">{{x.documentId}}</div>
                </div>

                <font-awesome-icon :icon="['far', 'trash-alt']" @click.stop="removeFromBasket(x)" v-if="mode === 'add'" />
              </div>
            </div>
          </div>
        </template>
        <div class="basket-empty" v-else>
          <font-awesome-icon :icon="['fas', 'shopping-bag']" class="basket-empty-icon" />
          <div>Your basket is empty</div>
        </div>
      </template>
    </fts-dropdown-select>

    <div class="basket-action" @click.prevent="addToBasket" v-if="mode === 'add' && selection && selection.length">Add to Basket</div>
  </div>
</template>

<script>
import { classificationStore } from "../store/classificationStore";
import { clientStore } from "../store/clientStore";

import FTSDropdownSelect from "./FTSDropdownSelect";
import FTSMoji from "./FTSMoji";

export default {
  components: {
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-moji": FTSMoji,
  },
  props: {
    mode: {
      type: String,
      default: 'add' // add (Client), put(QuickView, FullView)
    },
    selection: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    basketGroup: []
  }),
  methods: {
    addToBasket() {
      if (this.selection) {
        this.selection.forEach(x => {
          x.moduleId = this.moduleId
          this.basket.push(x)
        })
      }
    },
    removeFromBasket(x) {
      let storeBasket = clientStore.state.basket
      storeBasket.splice(storeBasket.indexOf(x), 1)
    },
    removeBasketItems(items) {
      items.forEach(x => {
        this.removeFromBasket(x)
      })
    },
    addToForm(basket) {
      if (this.mode !== 'add') {
        this.$emit("addToForm", basket)
        this.removeBasketItems(basket.items)
      }
    },
    moduleData(moduleId) {
      let menus = this.workspaceModules
      let findModule = menus.find(x => x.id == moduleId) || {}
      return { id: findModule.id, name: findModule.name, emoji: findModule.emoji}
    },
    basketSelectedItemsEtc(list) {
      let res = "";
      let itemsLen = list.length || 0

      function documentId(x) { 
        return x.documentId ? x.documentId : "(unknown)" 
      }

      list.filter((x, idx) => idx < (itemsLen === 2 ? 2 : 1))
        .map((x, idx, array) =>
          idx + 1 === array.length
            ? (res = res + documentId(x))
            : (res = res + documentId(x) + ", ")
        );

      if (itemsLen === 3) 
        return `${res} and 2 others...`
      else if (itemsLen > 3)
        return `${res} and ${(itemsLen - 1)} others...`

      return res;
    },
    basketExpandDetails(basket) {
      if (!basket.expand)
        this.$set(basket, 'expand' ,true)
      else
        this.$delete(basket, 'expand')
    }
  },
  computed: {
    moduleId() {
      return clientStore.getters.moduleId
    },
    workspaceModules() {
      return clientStore.state.workspaceModules || []
    },

    visibility() {
      // trigger basket
      return this.basket && this.mode === 'add' || (this.mode === 'put' && this.basketGroup && this.basketGroup.length)
    },
    activeClass() {
      return this.basket && this.basket.length || this.selection && this.selection.length
    },
    totalBasketItems() {
      if (this.basket && this.basket.length) {
        if (this.mode === 'add')
          return this.basket.length
        else 
          return lodash.reduce(this.basketGroup, (sum, n) => { 
            return sum + (n.items && n.items.length ? n.items.length : 0)
          }, 0)
      }
    },
    basket() {
      let basket = clientStore.state.basket
      let basketItems = []
      let fields = []

      if (this.mode === 'add') {
        basketItems = lodash.chain(basket)
          .groupBy('moduleId')
          .map((v, k) => ({ 
            moduleId: k, 
            items: v,
            expand: this.basketGroup && this.basketGroup.find(x => x.moduleId == k && x.expand)
          }))
          .value()
      } else {
        let form = classificationStore.state.form;
        if (form != null) {
          form.rows.forEach(x => {
            x.items.forEach(item => {
              if (item.type == 14 && Array.isArray(item.fields) && item.fields.length) {
                item.fields.forEach(field => {
                  if (field.type == 7) {
                    fields.push([item, field]);
                  }
                });
              }
            });
          });
        }

        fields.forEach(field => {
          let items = basket.filter(x => x.moduleId == field[1].connectionId);
          if (items.length) {
            basketItems.push({ 
              moduleId: items[0].moduleId, 
              fields: field, 
              items: items 
            });
          }
        });
      }

      this.basketGroup = basketItems
      return basket;
    },
    basketHeader() {
      const basketLen = this.basketGroup && this.basketGroup.length
      let basket = []

      if (basketLen === 4) {
        basket = lodash.take(this.basketGroup, 2)
        basket.push({
          id: "others",
          title: "2 others" 
        })
      } else if (basketLen > 4) {
        basket = lodash.take(this.basketGroup, 2)
        basket.push({
          id: "others",
          title: `${basketLen - 2} others` 
        })
      } else {
        basket = this.basketGroup
      }
      
      return basket
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-basket {
  display: flex;
  align-items: center;
  color: var(--fts-gray-5);
  &.active {
    .basket-toggle,
    .basket-action {
      color: $primaryColor;
    }
  }
  .basket-header {
    margin: -0.375rem .375rem -0.375rem -0.375rem;
    display: flex;
    align-items: center;
    .basket-header-wrapper {
      padding: .375rem;
      border-radius: .25rem;
      &:hover {
        background: var(--fts-gray-4);
      }
        .basket-header-others {
          font-size: .75rem;
          color: #000;
        }
        .basket-header-group {
          display: flex;
          align-items: center;
          .basket-module-name {
            @include text-overflow-hidden;
            max-width: 80px;
            margin-left: .175rem;
            font-size: .75rem;
            color: initial;
          }
          .basket-items-length {
            font-size: 0.675rem;
            margin-left: .175rem;
            min-width: .75rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--fts-gray-5);
            color: #fff;
            padding-left: 2px;
            padding-right: 2px;
            border-radius: 0.25rem;
          }
        }
    }
  }
  .basket-dropdown {
    .basket-toggle {
      position: relative;
      .basket-count {
        position: absolute;
        bottom: -3px;
        left: 50%;
        transform: translateX(-50%) scale(.7);
        color: #fff;
      }
    }
  }
  .basket-action {
    @include user-select-none;
    margin-left: .375rem;
    padding-top: .275rem;
    font-size: .875rem;
    cursor: pointer;
  }
}

.basket-content.basket-dropdown-menu {
  min-width: 400px;
  max-width: 400px;
  max-height: 500px;
  .basket-group {
    padding: .575rem 1rem;
    &:hover {
      background: var(--fts-gray-1);
    }
    .basket-summary {
      display: flex;
      align-items: center;  
      .basket-module {     
        min-width: 110px;
        max-width: 110px;
        display: flex;
        align-items: center;    
        margin-right: .75rem;
        padding-right: .75rem;
        border-right: 1px solid var(--fts-gray-3);
        .basket-module-emoji {
          margin-right: .375rem
        } 
        .basket-module-name {
          @include text-overflow-hidden;
          font-size: 1rem;
          font-weight: 500;
        }   
      }
      .basket-items {
        flex: 1;
        margin-right: .375rem;
        .basket-items-summary {
          font-size: .875rem;
          font-weight: 500;
        }
        .basket-items-details {
          font-size: .675rem;
          .basket-items-ids {
            margin-right: .375rem;
          }
          .basket-items-ids-action {
            color: $primaryColor;
            white-space: nowrap;
            cursor: pointer;
          }
        }
      }
    }
    .basket-item-container {
      padding-top: .75rem;
      padding-left: calc(110px + 0.75rem);
      .basket-item {
        display: flex;
        align-items: center;  
        &:not(:last-child) {
          margin-bottom: .375rem;
        }
        .basket-item-wrapper {
          min-width: 0;
          flex: 1;
          margin-right: .375rem;
          .basket-item-title {
            @include text-overflow-ellipsis;
            font-size: .875rem;
            font-weight: 500;
          }
          .basket-item-document {
            font-size: .675rem;
          }
        }
      }
    }
  }
  .basket-empty {
    padding: 1.5rem 0;
    text-align: center;
    .basket-empty-icon {
      margin-bottom: 1rem;
      font-size: 2.5rem;
      color: var(--fts-gray-5);
    }
  }
}
</style>